import { Box, Stack, Typography } from "@mui/material";
import {
  Lock as LockIcon,
  Shield as ShieldIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import AuthLayout from "../components/AuthLayout";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <AuthLayout title={t("app.title")}>
      <Box sx={{ textAlign: "center", mb: 1 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #42a5f5 0%, #1565c0 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 1,
          }}
        >
          <ShieldIcon sx={{ fontSize: 24, color: "#fff" }} />
        </Box>
        <Typography variant="h6" fontWeight={700}>
          {t("privacy.title")}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t("privacy.lastUpdate")}
        </Typography>
      </Box>

      <Stack spacing={2}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <LockIcon sx={{ fontSize: 18, color: "primary.main" }} />
            <Typography variant="subtitle2" fontWeight={600}>
              1. {t("privacy.strictlyNecessary.title")}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {t("privacy.strictlyNecessary.description")}
          </Typography>
          <Box component="ul" sx={{ pl: 2.5, mt: 0.5, mb: 0 }}>
            {(["item1", "item2", "item3", "item4"] as const).map((item) => (
              <Typography
                key={item}
                component="li"
                variant="caption"
                color="text.secondary"
                sx={{ mb: 0.25 }}
              >
                {t(`privacy.strictlyNecessary.${item}`)}
              </Typography>
            ))}
          </Box>
          <Box
            sx={{
              mt: 1,
              p: 1,
              borderRadius: 1,
              bgcolor: "action.hover",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {t("privacy.strictlyNecessary.alert")}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <VisibilityOffIcon sx={{ fontSize: 18, color: "primary.main" }} />
            <Typography variant="subtitle2" fontWeight={600}>
              2. {t("privacy.tracking.title")}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {t("privacy.tracking.description")}
          </Typography>
        </Box>

        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <ShieldIcon sx={{ fontSize: 18, color: "primary.main" }} />
            <Typography variant="subtitle2" fontWeight={600}>
              3. {t("privacy.security.title")}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {t("privacy.security.description")}
          </Typography>
        </Box>
      </Stack>
    </AuthLayout>
  );
}
